<template>
  <div id="app">
    
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    //判断是否为移动设备，是，则跳转到移动端的路由
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.$router.push({path:'mobile'})
    }else {
      this.$router.push({path:'/'})
    }

  },
}
</script>

<style>
html,body{
	height:100%;
	width:100%;
}
#app{
  	height:100%;
   	width:100%;
}
body .el-table th.gutter{
display: table-cell!important;
}
 
</style>



// WEBPACK FOOTER //
// src/App.vue